import {
    RequestedCreateEquipmentActionCreator,
    SuccceededCreateEquipmentActionCreator,
    FailedCreateEquipmentActionCreator,
    RequestedUpdateEquipmentActionCreator,
    SuccceededUpdateEquipmentActionCreator,
    FailedUpdateEquipmentActionCreator,
    RequestedDeleteEquipmentActionCreator,
    SuccceededDeleteEquipmentActionCreator,
    FailedDeleteEquipmentActionCreator,
    SetSingleEquipmentActionCreator,
    SetEquipmentActionCreator
} from './types';
import {
    EQUIPMENT_CREATE_REQUESTED,
    EQUIPMENT_CREATE_SUCCEEDED,
    EQUIPMENT_CREATE_FAILED,
    EQUIPMENT_UPDATE_REQUESTED,
    EQUIPMENT_UPDATE_SUCCEEDED,
    EQUIPMENT_UPDATE_FAILED,
    EQUIPMENT_DELETE_REQUESTED,
    EQUIPMENT_DELETE_SUCCEEDED,
    EQUIPMENT_DELETE_FAILED,
    EQUIPMENT_SINGLE_SET,
    EQUIPMENT_SET
} from './constants';

export const requestedCreateEquipment: RequestedCreateEquipmentActionCreator = (
    equipment
) => {
    return {
        type: EQUIPMENT_CREATE_REQUESTED,
        payload: equipment
    };
};

export const succeededCreateEquipment: SuccceededCreateEquipmentActionCreator = (
    response
) => {
    return {
        type: EQUIPMENT_CREATE_SUCCEEDED,
        payload: response
    };
};

export const failedCreateEquipment: FailedCreateEquipmentActionCreator = (
    error
) => {
    return {
        type: EQUIPMENT_CREATE_FAILED,
        payload: error,
        error: true
    };
};

export const requestedUpdateEquipment: RequestedUpdateEquipmentActionCreator = (
    equipmentId,
    equipment
) => {
    return {
        type: EQUIPMENT_UPDATE_REQUESTED,
        payload: {
            equipmentId,
            equipment
        }
    };
};

export const succeededUpdateEquipment: SuccceededUpdateEquipmentActionCreator = (
    response
) => {
    return {
        type: EQUIPMENT_UPDATE_SUCCEEDED,
        payload: response
    };
};

export const failedUpdateEquipment: FailedUpdateEquipmentActionCreator = (
    error
) => {
    return {
        type: EQUIPMENT_UPDATE_FAILED,
        payload: error,
        error: true
    };
};

export const requestedDeleteEquipment: RequestedDeleteEquipmentActionCreator = (
    equipmentId
) => {
    return {
        type: EQUIPMENT_DELETE_REQUESTED,
        payload: {
            equipmentId
        }
    };
};

export const succeededDeleteEquipment: SuccceededDeleteEquipmentActionCreator = (
    response
) => {
    return {
        type: EQUIPMENT_DELETE_SUCCEEDED,
        payload: response
    };
};

export const failedDeleteEquipment: FailedDeleteEquipmentActionCreator = (
    error
) => {
    return {
        type: EQUIPMENT_DELETE_FAILED,
        payload: error,
        error: true
    };
};

export const setSingleEquipment: SetSingleEquipmentActionCreator = (
    equipment
) => {
    return {
        type: EQUIPMENT_SINGLE_SET,
        payload: { [equipment.uuid]: equipment }
    };
};

export const setEquipment: SetEquipmentActionCreator = (equipment) => {
    return {
        type: EQUIPMENT_SET,
        payload: equipment
    };
};
